'use strict';

var React = require('react');
var breakpoints = require('../../../constants/breakpoints.cjs');

/**
 * Detects the current screen size based on the window width
 */ const useScreenSize = ()=>{
    const [screenSize, setScreenSize] = React.useState(breakpoints.SCREEN_SIZES.desktop1024);
    React.useEffect(()=>{
        if (typeof window === "undefined") return;
        const getScreenSize = ()=>{
            const width = window.innerWidth;
            if (width < breakpoints.MIN_BREAKPOINTS.tablet834) return breakpoints.SCREEN_SIZES.mobile375;
            if (width < breakpoints.MIN_BREAKPOINTS.desktop1024) return breakpoints.SCREEN_SIZES.tablet834;
            if (width < breakpoints.MIN_BREAKPOINTS.desktop1280) return breakpoints.SCREEN_SIZES.desktop1024;
            return breakpoints.SCREEN_SIZES.desktop1280;
        };
        const handleResize = ()=>{
            setScreenSize(getScreenSize());
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return screenSize;
};

exports.useScreenSize = useScreenSize;
//# sourceMappingURL=useScreenSize.cjs.map
